import React, { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'

import { projectContext, loadingContext, intentsContext, urlValue, unfolder, onImportExcelAsync, openAlert, useTranslate } from '../lib'
import SideBar from '../components/SideBar'
import { customModal } from '../styles/customModal'
import TitleBar from "../components/TitleBar";
import CheckBox2 from '../components/CheckBox2'
import Loading from '../components/Loading'
import BoxInfo from '../components/common/BoxInfo'
import { Tooltip } from 'react-tooltip'
import { NewVoice } from '../components/NewVoice'

import '../styles/voiceCRUD.scss'
import '../styles/voice.scss'

export default function Voices() {
  const [isModalOpen, setIsModalOpen] = useState({ delete: false, code: false });
  const [selectedVoice, setSelectedVoice] = useState({});
  const [sidePanel, setSidePanel] = useState('new');
  const [refresh, setRefresh] = useState(0);
  const ref = useRef(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useContext(loadingContext);
  const [sort, setSort] = useState('asc');
  const [voicesDelete, setVoicesDelete] = useState([]);
  const [modalDelete, setModalDelete] = useState(false);
  const [listVoices, setListVoices] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const { t } = useTranslate();

  useEffect(() => {
    const fetchInitialData = async () => {
      await getAllVoices();
      await fetchProjects();
    };
    
    fetchInitialData();
  }, []);


  const fetchProjects = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    
    try {
      const response = await axios.get(`${urlValue}/studio/user/all-projects/${id}`, {
        headers: { 'access-token': token, user: id }
      });
      setAllProjects(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getAllVoices = async () => {

    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/voice`,
      headers: {
        'access-token': token,
        'Content-Type': 'application/json',
      }
    })
      .then(function (response) {
        handleNewVoice()
        setListVoices(response?.data.data || [])
      })
      .catch(function (error) {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }
  function handleVoiceSelect(voice) {
    if (!voice) return;
    setSidePanel('edit');
    setSelectedVoice({
      ...voice,
      projects: voice.projects || [] // Asegurarse de que siempre haya un array de proyectos
    });
  }

  function handleNewVoice() {
    setSidePanel('new');
    setSelectedVoice({}); 
  }

  function openModal(voice) {
    setIsModalOpen({ delete: true, code: false })
    setSelectedVoice(voice)

  }

  const sortElementsChange = (e) => {
    setSort(e.target.value);
  }

  const sortElements = () => {
    let sortOrder = sort;
    let result;

    switch (sortOrder) {
      case 'asc':
        result = (a, b) => a.name?.toLowerCase() > b.name?.toLowerCase() ? 1 : -1;
        break;
      case 'desc':
        result = (a, b) => a.name?.toLowerCase() < b.name?.toLowerCase() ? 1 : -1;
        break;
    }

    return result;
  }

  const deleteAnswer = async (voiceId) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    setLoading(true);
    try {
      try {
        await axios({
          method: 'post',
          url: `${urlValue}/studio/voice/${voiceId}/delete`,
          headers: {
            'user': id,
            'access-token': token,
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          },
          withCredentials: true,
        })
        setIsModalOpen({ delete: false })
        getAllVoices()
      } catch (error) {
        return console.log(error)
      }
    } finally {
      return setLoading(false)
    }
  }


  const selectForDelete = (e, item) => {
    if (e.target.checked) {
      setVoicesDelete([...voicesDelete, item])
    } else {
      setVoicesDelete(voicesDelete.filter(x => x.id !== item.id));
    }
  }

  const selectAll = (e) => {
    if (e.target.checked) {
      document.querySelectorAll("#intent-all input[type='checkbox']").forEach((item) => {
        item.checked = true;
      })
    } else {
      document.querySelectorAll("#intent-all input[type='checkbox']").forEach((item) => {
        item.checked = false;
      })
    }
  }
  const deleteMultiple = async() => {
    if (voicesDelete.length === 0) {
      return;
    }

    setLoading(true);

    const deleteRequests = voicesDelete.map(voice => deleteAnswer(voice.id));

    Promise.all(deleteRequests)
      .then(() => {
        setVoicesDelete([]);
        setModalDelete(false);
        setRefresh(refresh + 1);
      })
      .catch(error => {
        console.error('Error deleting voices:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <section className="container-voices general-container" id="container">
        {/* <SideBar active={'Voices'} /> */}
        <div className="row_primary">
          <div className="con_title_bar">
            <TitleBar />
          </div>
          <div className="con_header">
            <div className="header">
              <div className="title">
                <div className="head justify-end flex-1">
                  <button id='newbtn-tp' className="newProject  btn-top btn-top-new " style={{ marginLeft: 6, }} onClick={() => { handleNewVoice() }}>
                    {/* <img src="/icons/new.png" alt="newAns" /> */}
                    <span>{t('voice.new')}</span>
                    <Tooltip anchorSelect="#newbtn-tp" content={t('voice.createTooltip')} place="top" />
                  </button>
                  <button id='delete-tp' className="newProject btn-top btn-top-new" style={{ marginLeft: 6 }} onClick={() => setModalDelete(true)}>
                    <span>{t('common.delete')}</span>
                    <Tooltip anchorSelect="#delete-tp" content={t('voices.deleteTooltip')} place="top" />
                  </button>
                </div>
              </div>

            </div>
            <div className="container-info">

              <div className="body-container">
                <div className="body left-c " id="intent-all">
                  <div className="flex flex-row items-center pb-2 ml-2">
                    <div className="search-iva input-search">
                      <input
                        type="text"
                        placeholder={t('voice.searchPlaceholder')}
                        onChange={event => {
                          setSearch(event.target.value)
                        }}
                      />
                      <img src="/icons/search.svg" alt="" />
                    </div>
                    <div className="flex-1 d-flex flex-row  items-center justify-end ">
                      <label htmlFor="sort" className='title-search'>{t('common.organize')}:</label>
                      <select onChange={sortElementsChange} name="" id="sort" className="  input-search select-nesting"
                        style={{ border: '1px solid gray', borderRadius: 20, padding: "0px 7px 0 9px", marginLeft: 8, minWidth: 100, height: 35, fontSize: 18, backgroundPositionX: "80%" }}>
                        <option value="asc" selected>{t('common.asc')}</option>
                        <option value="desc">{t('common.desc')}</option>
                      </select>
                    </div>
                  </div>

                  <div className="elements">
                    {listVoices.length > 0 &&
                      <div className='rounded-md flex items-center' style={{ marginLeft: 20, marginRight: 20, paddingLeft: 15 }}>
                        <CheckBox2 onChange={(e) => selectAll(e)} default={false} id={`ck-all-proj`} text="" />
                        <label><b></b>{t('voice.selectAll')}</label>
                      </div>}
                    {listVoices.length > 0 && listVoices
                      .filter(value => {
                        if (search == '') {
                          return value
                        } else if (
                          value.name.toLowerCase().includes(search.toLowerCase())
                        ) {
                          return value
                        }
                      })
                      .sort(sortElements())
                      .map((voice, index) => (
                        <div 
                          className="element" 
                          key={index} 
                          onClick={() => handleVoiceSelect(voice)}
                          style={{
                            // Estilos para resaltar la voz seleccionada
                            border: selectedVoice.id === voice.id ? '2px solid #0078d7' : '1px solid transparent',
                            backgroundColor: selectedVoice.id === voice.id ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px',
                            margin: '2px 10px',
                            transition: 'all 0.2s ease',
                            boxShadow: selectedVoice.id === voice.id ? '0 2px 8px rgba(0, 120, 215, 0.2)' : 'none'
                          }}
                        >
                          <div className="answer">
                            <CheckBox2 onChange={(e) => selectForDelete(e, voice)} default={false} id={`${voice.name}`} text="" />
                            <div className='list-color' style={{
                              fontWeight: selectedVoice.id === voice.id ? '600' : 'normal',
                              color: selectedVoice.id === voice.id ? '#0078d7' : 'inherit'
                            }}>
                              {voice.name}
                            </div>
                            <div className="options_container">
                              <img
                                id={`delete-tp-${index}`}
                                src="/icons/trash.png"
                                alt="trash"
                                onClick={(e) => {
                                  e.stopPropagation(); // Evitar que se seleccione la voz al hacer click en eliminar
                                  openModal(voice);
                                }}
                              />
                              <Tooltip anchorSelect={`#delete-tp-${index}`} content={t('common.delete')} place="top" />
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>

                </div>

                <div className="container-edit right-c">
                  {(sidePanel === 'edit' || sidePanel === 'new') && (
                    <NewVoice
                      selectedVoice={selectedVoice}
                      refresh={refresh}
                      setRefresh={setRefresh}
                      update={getAllVoices}
                      sidePanel={sidePanel}
                      allProjects={allProjects}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
      <Modal isOpen={isModalOpen.delete} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" />
          <h1>{t('voice.deleteConfirmTitle')}</h1>
          <h1>{t('menu.deleteConfirmQuestion')}</h1>
          <div className="buttons-modal">
            <button
              onClick={() => setIsModalOpen({ delete: false, code: false })}
              className="cancel btn-modal-cancel"
            >
              {t('common.cancel')}
            </button>
            <button onClick={() => deleteAnswer(selectedVoice.id)} className="accept">
              {t('common.accept')}
            </button>
          </div>
        </div>
      </Modal>


      <Modal isOpen={modalDelete} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" alt='' />
          <h1>{t('voice.deleteMultipleConfirmTitle')}</h1>
          <h1>{t('menu.deleteConfirmQuestion')}</h1>
          <div className="buttons-modal">
            <button
              onClick={() => setModalDelete(false)}
              className="cancel btn-modal-cancel"
            >
              {t('common.cancel')}
            </button>
            <button onClick={() => { deleteMultiple() }} className="accept">
              {t('common.accept')}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}